import Axios from 'axios'
import { URL } from '../constants/Urls'

export const sendBusinessDetails = async (data) => {
  return await Axios.post(URL.SEND_BUSINESS_DETAILS, data)
}
